<eva-dialog
  type="form"
  [(visible)]="visible"
  [closable]="false"
  [dismissible]="false"
  width="820px"
  [header]="getBreadcrumbText()"
  [contentStyle]="{ padding: '0' }"
  styleClass="task-detail-dialog"
  (onHide)="onDialogHide()"
>
  <div dialog-header-actions class="task-detail-header-actions">
    <!-- Navigation prev/next -->
    <eva-button
      icon="heroChevronUp"
      variant="text"
      [rounded]="true"
      size="small"
      (onClick)="goToPrev()"
      [disabled]="!canGoPrev"
      tooltip="Tâche précédente"
      tooltipPosition="bottom"
    ></eva-button>
    <eva-button
      icon="heroChevronDown"
      variant="text"
      [rounded]="true"
      size="small"
      (onClick)="goToNext()"
      [disabled]="!canGoNext"
      tooltip="Tâche suivante"
      tooltipPosition="bottom"
    ></eva-button>

    <!-- Menu contextuel -->
    <eva-button
      icon="heroEllipsisHorizontal"
      variant="text"
      [rounded]="true"
      size="small"
      (onClick)="contextMenu.toggle($event)"
      tooltip="Plus d'actions"
      tooltipPosition="bottom"
    ></eva-button>
    <eva-menu #contextMenu [items]="contextMenuItems" />

    <!-- Fermer -->
    <eva-button
      icon="heroXMark"
      variant="text"
      [rounded]="true"
      size="small"
      (onClick)="close()"
      tooltip="Fermer"
      tooltipPosition="bottom"
    ></eva-button>
  </div>

  <!-- Body : 2 colonnes -->
  <div class="task-detail-body" *ngIf="task">
    <!-- Colonne gauche : contenu principal -->
    <div class="task-detail-left">
      <!-- Titre avec checkbox -->
      <div class="task-detail-title-row">
        <div
          class="task-detail-checkbox"
          [class.task-detail-checkbox--done]="task.status === 'DONE'"
          [class.task-detail-checkbox--celebrating]="celebrating"
          (click)="markAsDone()"
          evaTooltip="Marquer comme terminée"
          evaTooltipPosition="right"
        >
          <i
            class="pi"
            [class.pi-check]="task.status === 'DONE' || celebrating"
            [class.pi-circle]="task.status !== 'DONE' && !celebrating"
          ></i>
        </div>

        <div class="task-detail-title-wrapper">
          <!-- Mode lecture -->
          <h2
            *ngIf="!titleEditing"
            class="task-detail-title"
            [class.task-detail-title--done]="task.status === 'DONE'"
            (click)="startTitleEdit()"
          >
            {{ editTitle }}
          </h2>
          <!-- Mode edition -->
          <eva-input
            *ngIf="titleEditing"
            type="text"
            [(ngModel)]="editTitle"
            (ngModelChange)="onTitleChange()"
            (onBlur)="onTitleBlur()"
            (keydown.enter)="onTitleBlur()"
            [autofocus]="true"
          />
        </div>
      </div>

      <!-- Description -->
      <div class="task-detail-description">
        <eva-textarea
          [(ngModel)]="editDescription"
          (ngModelChange)="onDescriptionChange()"
          placeholder="Ajouter une description..."
          [rows]="3"
        ></eva-textarea>
      </div>

      <!-- Sous-tâches et commentaires : masqués tant qu'ils ne sont pas branchés (EP-1120) -->
    </div>

    <!-- Colonne droite : metadonnees -->
    <div class="task-detail-right">
      <!-- Statut (action principale) -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Statut</span>
        <eva-select
          [options]="statusOptions"
          [(ngModel)]="editStatus"
          (ngModelChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          [showTag]="true"
        ></eva-select>
      </div>

      <!-- Dates (mode : aucune / échéance / période) -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Date</span>
        <div class="task-detail-date-section">
          <eva-toggle-switch
            [options]="dateModeOptions"
            [value]="dateMode"
            (valueChange)="onDateModeChange($event)"
            size="small"
          ></eva-toggle-switch>

          <!-- Mode échéance -->
          <ng-container *ngIf="dateMode === 'deadline'">
            <eva-datepicker
              placeholder="Choisir une date"
              [showPresets]="true"
              [clearable]="true"
              size="small"
              [value]="editDueDate"
              (valueChange)="onDeadlineDateChange($event)"
            ></eva-datepicker>
            <span *ngIf="task.isOverdue()" class="task-detail-overdue-badge">
              <ng-icon name="heroExclamationCircle"></ng-icon> En retard
            </span>
          </ng-container>

          <!-- Mode période -->
          <ng-container *ngIf="dateMode === 'range'">
            <eva-datepicker
              placeholder="Début → Fin"
              [range]="true"
              [clearable]="true"
              size="small"
              [value]="rangeDateValue"
              (valueChange)="onRangeDateChange($event)"
            ></eva-datepicker>
            <span *ngIf="task.isOverdue()" class="task-detail-overdue-badge">
              <ng-icon name="heroExclamationCircle"></ng-icon> En retard
            </span>
          </ng-container>
        </div>
      </div>

      <!-- Assigné à -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Assigné à</span>
        <app-task-assignee-picker
          [assignees]="editAssignedTo"
          [employees]="employees"
          placeholder="Assigner"
          (assigneesChange)="onAssigneesChange($event)"
        ></app-task-assignee-picker>
      </div>

      <!-- Priorité -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Priorité</span>
        <app-task-priority-picker
          [(priority)]="editUrgency"
          (priorityChange)="onUrgencyChange()"
          [showLabel]="true"
        ></app-task-priority-picker>
      </div>

      <!-- Lier à -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Lier à</span>
        <div class="task-detail-link-picker">
          <!-- Bouton + tags sur la même ligne (pattern notes) -->
          <div class="task-detail-link-row">
            <div class="task-detail-link-wrapper">
              <eva-button
                label="Lier à..."
                icon="heroLink"
                variant="text"
                size="small"
                (onClick)="toggleLinkSearch()"
              ></eva-button>

              <div class="task-detail-link-dropdown" *ngIf="showLinkSearch">
                <eva-input
                  icon="heroMagnifyingGlass"
                  [clearable]="true"
                  placeholder="Rechercher un chantier, client, offre..."
                  size="inline"
                  [value]="linkSearchQuery"
                  (valueChange)="onLinkSearch($event)"
                  [autofocus]="true"
                ></eva-input>

                <div class="task-detail-link-searching" *ngIf="isSearchingLinks">
                  <ng-icon name="evaSpinner" class="eva-icon-spin"></ng-icon>
                  <span>Recherche en cours...</span>
                </div>

                <div class="task-detail-link-results" *ngIf="linkSearchResults.length > 0">
                  <div *ngFor="let group of linkSearchResults" class="task-detail-link-group">
                    <div class="task-detail-link-group-label">
                      <i class="pi" [ngClass]="group.object_type_icon"></i>
                      {{ group.object_type_label }}
                    </div>
                    <button
                      type="button"
                      *ngFor="let item of group.items"
                      class="task-detail-link-result-item"
                      (click)="addObjectLink(group.object_type, item.object_id, item.label)"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tags objets liés (inline avec le bouton) — liens verrouillés masqués (contexte courant) -->
            <ng-container *ngFor="let link of task.objects_links">
              <eva-tag
                *ngIf="!isLocked(link)"
                [preset]="getObjectLinkPreset(link)"
                [removable]="true"
                (onRemove)="removeObjectLink(link.object_type, link.object_id)"
              ></eva-tag>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Visibilité (privé/public) -->
      <div class="task-detail-meta-item">
        <span class="task-detail-meta-label">Visibilité</span>
        <app-task-visibility-toggle
          [(isPrivate)]="editIsPrivate"
          (isPrivateChange)="onPrivateChange()"
        ></app-task-visibility-toggle>
      </div>

      <!-- Dates audit (lecture seule) -->
      <div class="task-detail-meta-item task-detail-meta-info" *ngIf="task.created_at">
        <span class="task-detail-meta-label-sm">Créée le {{ task.created_at | date: "dd.MM.yyyy" }}</span>
      </div>
      <div class="task-detail-meta-item task-detail-meta-info" *ngIf="task.updated_at">
        <span class="task-detail-meta-label-sm">Modifiée le {{ task.updated_at | date: "dd.MM.yyyy" }}</span>
      </div>
    </div>
  </div>
</eva-dialog>
